import React from 'react';
import { IconActionArrowUpRight16 } from '@cian/ui-kit-design-tokens/icons';
import { UIHeading1 } from '@cian/ui-kit/typography';
import { Container } from '../Container/Container';
import { Link } from '../Link/Link';
import { ReviewItem, type IReview } from '../ReviewItem/ReviewItem';
import styles from './Reviews.css';

export type { IReview };

interface IReviewsProps {
  reviews: IReview[];
  onReviewItemClick: (review: IReview) => void;
  onAllReviewsClick: () => void;
}

export const Reviews: React.FC<IReviewsProps> = ({ reviews, onReviewItemClick, onAllReviewsClick }) => {
  return (
    <Container dataName="Reviews">
      <div className={styles['header']}>
        <UIHeading1 color="black_100">Обзоры загородных проектов</UIHeading1>
        <Link href="/magazine-stroim-dom/" target="_blank" className={styles['link']}>
          <div className={styles['link-title']} onClick={onAllReviewsClick}>
            Все обзоры
          </div>{' '}
          <IconActionArrowUpRight16 color="current_color" />
        </Link>
      </div>
      <div className={styles['reviews']}>
        {reviews.map((review, index) => {
          return (
            <div className={styles['review-item']} key={index} onClick={() => onReviewItemClick(review)}>
              <ReviewItem {...review} />
            </div>
          );
        })}
      </div>
    </Container>
  );
};
